module.exports = __webpack_public_path__ + "img/34.cede68c3.png";